import script from "./InstitutionView.vue?vue&type=script&setup=true&lang=js"
export * from "./InstitutionView.vue?vue&type=script&setup=true&lang=js"

import "./InstitutionView.vue?vue&type=style&index=0&id=7f1fffdd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.32_webpack@5.106.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f1fffdd"]])

export default __exports__